export function getOrigin(): string {
  return import.meta.env.VITE_AUREA_API_ORIGIN || location.origin;
}

export function getUrl(endpoint: string): string {
  return `${getOrigin()}/${endpoint.replace(/^\//, "")}`;
}
